import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  metaInfo() {
    return {
      title: 'News',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
    installCategoryNav() {
      const categoryNav = this.$el.querySelector('#g-newshubpage .g_newshubpage_cls_category-nav');
      const categoryNavButtons = categoryNav ? categoryNav.querySelectorAll('button') : [];
      const newsItems = this.$el.querySelectorAll('#g-newshubpage .g_newshubpage_cls_js-news-item');

      categoryNavButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          categoryNavButtons.forEach((btn) => btn.classList.remove('g_newshubpage_cls_active'));
          e.currentTarget.classList.add('g_newshubpage_cls_active');

          const category = e.currentTarget.textContent.trim();
          newsItems.forEach((item) => {
            const itemCategory = item.getAttribute('data-category') || '';
            const show = category === 'All' || itemCategory === category;
            item.style.display = show ? '' : 'none';
          });
        });
      });
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.NEWS)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
        this.$nextTick(() => {
          this.installCategoryNav();
        });
      })
      .then(() => this.loaderRemove(document.body))
      .catch(() => {
        this.isComponentReady = true;
        this.loaderRemove(document.body);
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-news-stories/page-news-stories.js